module.exports = __webpack_public_path__ + "img/img_2.06fe5964.png";